export const environment = {
  production: false,
  domain: 'localhost:4200',
  region: 'ap-northeast-1',
  api_base_url: 'https://develop.apisec.online-pci-nxtg.net/v1/',
  chime_url: 'https://develop.apisec.online-pci-nxtg.net/v1/chime/',
  userPoolIdForPharmacy: 'ap-northeast-1_WpOmwIENF',
  clientIdForPharmacy: '6gr04qht1uadqkq2v6298mc4ek',
  userPoolIdForPharmacist: 'ap-northeast-1_gpcRzD4d7',
  clientIdForPharmacist: '7q2h2n0vm7bi6lclk7a5ne469e',
  title: 'NXTG開発環境',
  windowTitle: 'Connect Online (NXTG develop)',
  firebase: {
    apiKey: 'AIzaSyBmvOHWh4VLBbZhR33vbS4DBezAavHLMn8',
    authDomain: 'connect-online-3520a.firebaseapp.com',
    projectId: 'connect-online-3520a',
    storageBucket: 'connect-online-3520a.appspot.com',
    messagingSenderId: '585045901396',
    appId: '1:585045901396:web:2d003a5631d47ddf462dc1',
    measurementId: 'G-LV945C3Z1X',
  },
};  
